import "./Download.scss";
import { DialogBase } from "components/Dialog/Base";
import { FormDownload } from "components/Form/Download";

export function DialogDownload() {
    console.log('DialogDownload mounted');

    DialogBase();
    FormDownload();
}